const $ = jQuery.noConflict();

'use strict';
const Subscribe = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.subscribe();
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	subscribe() {
		function isValidEmail(email) {
			const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
			return emailPattern.test(email);
		}

		function setSubscribeEmail() {
			const email = $('.js-subscription-email').val();
			if (isValidEmail(email)) {
				$.ajax({
					type: 'POST',
					url: window.fwsLocalized.ajaxUrl,
					data: {
						action: 'store_email',
						email: email,
					},
					success: function(response) {
						console.log(response);
						$('.js-after-submit').text(response.data);
						$('.js-error-submit').text(response.data);
						if (response.data !== 'Email is allready subscribed') {
							$('.js-subscription').addClass('done');
							$('.js-subscription').removeClass('error');
							$('.js-after-submit').show();
							$('.js-error-submit').hide();
						} else {
							$('.js-subscription').addClass('error');
							$('.js-subscription').removeClass('done');
							$('.js-after-submit').hide();
							$('.js-error-submit').show();
						}
					},
					error: function(jqXHR, textStatus, errorThrown) {
						// Handle error, if needed
						console.error('AJAX Error:', textStatus, errorThrown);
						$('.js-subscription').addClass('error');
						$('.js-subscription').removeClass('done');
						$('.js-after-submit').hide();
						$('.js-error-submit').show();
					},
				});
			} else {
				$('.js-subscription').addClass('error');
				$('.js-subscription').removeClass('done');
				$('.js-after-submit').hide();
				$('.js-error-submit').show();
			}

			setTimeout(function() {
				$('.js-subscription').removeClass('done error');
				$('.js-subscription-email').val('');
			}, 2000);
		}

		$('.js-submit-email').on('click', function(e) {
			e.preventDefault();

			setSubscribeEmail();
		});

		$('.js-subscription-email').on('keypress', function(e) {
			if (e.key === 'Enter') {
				e.preventDefault();

				setSubscribeEmail();
			}
		});
	}
};

export default Subscribe;